/* A3 lite: evidence appears progressively on scroll, no separate timeline and no duplicated metrics.
   Read-only page behaviour. Does not touch carts, prices, themes outside Collagène A3. */
(function(){
  'use strict';
  var instance=null;
  function boot(){
    if(!document.querySelector('[data-collagene-a3-lite]'))return;
    var science=document.querySelector('.eclo-science-v16[id^="EcloScienceV16--"]');
    if(!science||science.dataset.a3LiteBooted==='true')return;
    var items=Array.from(science.querySelectorAll('.eclo-science-v16__study'));
    if(!items.length)return;
    document.body.classList.add('eclo-collagene-a3-lite');
    science.dataset.a3LiteBooted='true';
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduced||!('IntersectionObserver' in window)){
      items.forEach(function(el){el.classList.add('a3-lite-visible')});
      science.dataset.a3LiteReveal='static';
      return;
    }
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        entry.target.classList.add('a3-lite-visible');
        observer.unobserve(entry.target);
      });
    },{threshold:0.12,rootMargin:'0px 0px -8% 0px'});
    items.forEach(function(el){observer.observe(el)});
    science.classList.add('a3-lite-motion');
    science.dataset.a3LiteReveal='scroll';
    var marker=document.querySelector('[data-collagene-a3-lite]');
    marker.dataset.a3LiteCount=String(items.length);
    // Reversibility/editor cleanup only, not auto-scrolling.
    instance={observer:observer,science:science};
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',function(e){
    if(instance&&e.target.contains(instance.science)){
      instance.observer.disconnect();
      instance=null;
    }
  });
})();
